import React, { useState, useMemo } from "react";
import { Images } from "./Images";
import { useTranslation } from 'react-i18next';
const SpotTags = ({ spotTagList }) => {
    const { t } = useTranslation("common");
    const [showTags, setShowTags] = useState(false);

    const tags = useMemo(() => {
        return Array.isArray(spotTagList) ? spotTagList : [];
    }, [spotTagList]);

    if (!tags.length) return null;

    return (
        <div className="modal-tag">
            <button id="show-tag-tab"
                type="button"
                className={showTags ? "active" : ""}
                onClick={() => setShowTags(prev => !prev)}             >
                <img src={Images.ModalTag} className="img-fluid" alt="Tags" />
                <span className="show-link">{t("show_tags")}</span>
                <span className="hide-link">{t("react_hide_tags")}</span>
            </button>

            <div id="all-tags" className={showTags ? "show" : ""}>
                {tags.map(tag => (
                    <button key={tag.Id} type="button" >
                        {tag.TagName}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SpotTags;

